import { TransactionItem } from './item.model';

export enum ApproveStatus {
  Imported    = 0,
  Pending     = 1,
  SendFailed  = 2,
  Finished    = 3,
  Cancelled   = 4,
  Timeouted   = 5
}

export interface TransactionOverviewDto {
  notificationId: number;
  title:          string;
  body:           string;
  createdAt:      string;
  status:         ApproveStatus;
  storeName:      string;
  readAt?:        string | null;
  isRead:         boolean;
}

export interface Transaction {
  id:         number;
  title:      string;
  message:    string;
  createdAt:  string;
  status:     ApproveStatus;
  store:      string;
}
